import { RootState } from '../index';
import { ISubscription, SubscriptionsStore } from './types';

export const subscriptionsSelector = () => {
  return (state: RootState): SubscriptionsStore => state.subscriptions;
};

export const subscriptionBySpecialistSelector = (therapistID: string) => {
  return (state: RootState): ISubscription[] =>
    state.subscriptions?.data?.filter((el) => el.therapist_id === therapistID) ?? [];
};

export const lastActiveSubscriptionSelector = (therapistID?: string) => {
  return (state: RootState): ISubscription | null =>
    findActiveSubscriptionByTherapistId(state.subscriptions?.data, therapistID);
};

export const lastActiveSubscriptionAvailableBalanceSelector = (therapistID?: string) => {
  return (state: RootState): number => {
    const activeSubscription = findActiveSubscriptionByTherapistId(state.subscriptions?.data, therapistID);
    if (!activeSubscription) return 0;
    return activeSubscription.session_count - activeSubscription.used_balance;
  };
};

export const findActiveSubscriptionByTherapistId = (subscriptions: ISubscription[] | null, therapistID?: string) =>
  subscriptions?.find((el) => {
    if (therapistID) {
      return el.subscription_status === 'active' && el.therapist_id === therapistID;
    } else {
      return el.subscription_status === 'active';
    }
  }) ?? null;
